import { login, logout, getInfo } from '@/api/login'
import { profile } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import Cookies from "js-cookie";

const user = {
  state: {
    userId: "",
    token: getToken(),
    name: '',
    avatar: '',
    info: "",
    postGroup: "",
    roleGroup: "",
    roles: [],
    permissions: []
  },

  mutations: {
    SET_USERID: (state, id) => {
      state.userId = id
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_POSTGROUP: (state, postGroup) => {
      state.postGroup = postGroup
    },
    SET_ROLEGROUP: (state, roleGroup) => {
      state.roleGroup = roleGroup
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_MECHANISM: (state, isMechanism) => {
      state.isMechanism = isMechanism
    },
    SET_PROFESSION: (state, isProfession) => {
      state.isProfession = isProfession
    },
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          setToken(res.token)
          commit('SET_TOKEN', res.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo1 ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(res => {
          const user = res.user
          const avatar = user.picimg == "" ? require("@/assets/images/back/cardimg.jpg") : user.picimg;
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.roles)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_NAME', user.username)
          commit('SET_AVATAR', avatar)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        profile().then((res) => {
          if (parseInt(res.data.code) === 200) {
            commit('SET_NAME', res.data.data.userName);
            commit('SET_ROLES', res.data.data.roles);
            // commit('SET_PERMISSIONS', res.data.data.info.permissions);
            commit('SET_INFO', res.data.data);
            Cookies.set("userInfo", JSON.stringify({ 'userId': res.data.data.id }));
            commit('SET_POSTGROUP', res.data.postGroup);
            commit('SET_ROLEGROUP', res.data.roleGroup);
            commit("SET_USERID", res.data.data.id);
            commit('SET_AVATAR', res.data.data.picImg);
            // 保存用户是否进行专业人员入驻或机构入驻
            commit('SET_MECHANISM', res.data.isMechanism);
            commit('SET_PROFESSION', res.data.isProfession);
            resolve(res);
          }
        }).catch((err) => {
          reject(err);
        });
      });

    },

    // 退出系统
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          Cookies.set("userInfo", '');
          commit('SET_TOKEN', '');
          commit('SET_NAME', '');
          commit('SET_ROLES', '');
          // commit('SET_PERMISSIONS', res.data.data.info.permissions);
          commit('SET_INFO', '');

          commit('SET_POSTGROUP', '');
          commit('SET_ROLEGROUP', '');
          commit("SET_USERID", '');
          commit('SET_AVATAR', '');
          commit('SET_MECHANISM', '');
          commit('SET_PROFESSION', '');
          Cookies.remove("userInfo")
          removeToken()
          resolve()
          /*window.location.href = "http://wzfg.jrdsj.com";*/
          // window.location.href = "http://bgm.wuzhengai.com";
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js